import {
  SET_ARTWORKS,
  SET_SINGLE_ARTWORK,
  SET_ARTWORK_LOADING,
  SET_ARTWORK_ERROR
} from '../actionTypes'

export function setArtworks(input) {
  return {
    type: SET_ARTWORKS,
    payload: input
  }
}

export function setSingleArtwork(input) {
  return {
    type: SET_SINGLE_ARTWORK,
    payload: input
  }
}

export function setArtworkLoading(input) {
  return {
    type: SET_ARTWORK_LOADING,
    payload: input
  }
}

export function setArtworkError(input) {
  return {
    type: SET_ARTWORK_ERROR,
    payload: input
  }
}

export function fetchArtworks() {
  return (dispatch) => {
    dispatch(setArtworkLoading(true))
    fetch('https://api.artic.edu/api/v1/artworks?fields=id,title,artist_display,date_display,image_id,thumbnail,artist_title&limit=60')
      .then(response => response.json())
      .then(data => {
        dispatch(setArtworks(data))
      })
      .catch(err => {
        console.log(err)
        dispatch(setArtworkError(true))
      })
      .finally(() => {
        dispatch(setArtworkLoading(false))
      })
  }
}

export function fetchSingleArtwork(id) {
  return (dispatch) => {
    dispatch(setArtworkLoading(true))
    fetch(`https://api.artic.edu/api/v1/artworks/${id}?fields=id,title,artist_display,date_display,image_id,thumbnail,artist_title,date_start,date_end,place_of_origin,medium_display,dimensions,credit_line,provenance_text,copyright_notice`)
      .then(response => response.json())
      .then(data => {
        dispatch(setSingleArtwork(data))
      })
      .catch(err => {
        console.log(err)
        dispatch(setArtworkError(true))
      })
      .finally(() => {
        dispatch(setArtworkLoading(false))
      })
  }
}

export function fetchSearchArtworks(searchQuery) {
  return (dispatch) => {
    dispatch(setArtworkLoading(true))
    fetch(`https://api.artic.edu/api/v1/artworks/search?q=${searchQuery}&fields=id,title,artist_display,date_display,image_id,thumbnail,artist_title`)
      .then(response => response.json())
      .then(data => {
        dispatch(setArtworks(data))
      })
      .catch(err => {
        console.log(err)
        dispatch(setArtworkError(true))
      })
      .finally(() => {
        dispatch(setArtworkLoading(false))
      })
  }
}